/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ConflictProblemDto } from '../models';
// @ts-ignore
import type { DefinitionHistoryDto } from '../models';
// @ts-ignore
import type { ProblemDetailDto } from '../models';
// @ts-ignore
import type { TestDefinitionDto } from '../models';
// @ts-ignore
import type { TestDetailsDto } from '../models';
// @ts-ignore
import type { TestPageDto } from '../models';
// @ts-ignore
import type { TestPoolDto } from '../models';
// @ts-ignore
import type { TestPoolRequestDto } from '../models';
// @ts-ignore
import type { TestPurposeDto } from '../models';
// @ts-ignore
import type { TestRefusalDto } from '../models';
// @ts-ignore
import type { TestSampleDto } from '../models';
// @ts-ignore
import type { TestStatusDto } from '../models';
/**
 * TestsApi - axios parameter creator
 * @export
 */
export const TestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Only a test without gaps: at least one part, enough questions in every part in every language of the test, and — when the test has instructions — one in each of its languages. A retired test comes back only while no other test that is not retired has its name. Activating an active test changes nothing.
         * @summary Make a draft active, or bring a retired test back
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateTest: async (testId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('activateTest', 'testId', testId)
            const localVarPath = `/api/v1/tests/{testId}/activate`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Tests come in series — the closing test of a stage for one position after another — and differ in a detail. The copy is a draft named after the original with \"(kopia)\", or \"(kopia 2)\" and on when that name is taken.
         * @summary Copy a test into a new draft
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyTest: async (testId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('copyTest', 'testId', testId)
            const localVarPath = `/api/v1/tests/{testId}/copy`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a test, as a draft
         * @param {TestDefinitionDto} testDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTest: async (testDefinitionDto: TestDefinitionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testDefinitionDto' is not null or undefined
            assertParamExists('createTest', 'testDefinitionDto', testDefinitionDto)
            const localVarPath = `/api/v1/tests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testDefinitionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Only a draft that has never been active: a test that has been in use may have attempts behind it, and is retired rather than deleted.
         * @summary Delete a draft
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTest: async (testId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('deleteTest', 'testId', testId)
            const localVarPath = `/api/v1/tests/{testId}`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary A test with everything it is made of
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTest: async (testId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('getTest', 'testId', testId)
            const localVarPath = `/api/v1/tests/{testId}`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary What happened to a test, newest first
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestHistory: async (testId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('getTestHistory', 'testId', testId)
            const localVarPath = `/api/v1/tests/{testId}/history`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary The pool of a saved test, as the question bank stands now
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestPool: async (testId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('getTestPool', 'testId', testId)
            const localVarPath = `/api/v1/tests/{testId}/pool`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List tests
         * @param {TestPurposeDto} [purpose] 
         * @param {TestStatusDto} [status] 
         * @param {string} [categoryId] Narrows to tests with a part drawing from this category.
         * @param {string} [q] A fragment of the name, letter case aside.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sort] Field and direction, updatedAt or name, for example \&quot;name,asc\&quot;. Newest change first by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTests: async (purpose?: TestPurposeDto, status?: TestStatusDto, categoryId?: string, q?: string, page?: number, size?: number, sort?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (purpose !== undefined) {
                localVarQueryParameter['purpose'] = purpose;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For the pool panel of the form, asked again as parts, purpose and languages change. Parts are checked as a save checks them; the name and the rest of the definition are not needed.
         * @summary The pool of a test as the form holds it, nothing saved
         * @param {TestPoolRequestDto} testPoolRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewTestPool: async (testPoolRequestDto: TestPoolRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testPoolRequestDto' is not null or undefined
            assertParamExists('previewTestPool', 'testPoolRequestDto', testPoolRequestDto)
            const localVarPath = `/api/v1/tests/pool`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testPoolRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A retired test cannot be started any more; its definition and attempts stay. A draft has never been in use and is deleted instead. Retiring a retired test changes nothing.
         * @summary Retire an active test
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retireTest: async (testId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('retireTest', 'testId', testId)
            const localVarPath = `/api/v1/tests/{testId}/retire`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The same draw a person taking the test gets: parts in their order, questions and answers shuffled within each part, every question once, by the rules of the pool. Each call draws anew. In a language with too few questions the draw is refused, with the gaps listed.
         * @summary Draw the test as a person could get it, nothing saved
         * @param {string} testId 
         * @param {string} locale A language of the test.
         * @param {string} [positionCode] The position of the person taking the test: only questions for every position or for this one are drawn. A whole category or chosen questions with nothing for it are left out; a part that draws needs its number for the position too, or the draw is refused. Absent for every question, whoever it is for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sampleTest: async (testId: string, locale: string, positionCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('sampleTest', 'testId', testId)
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('sampleTest', 'locale', locale)
            const localVarPath = `/api/v1/tests/{testId}/sample`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (positionCode !== undefined) {
                localVarQueryParameter['positionCode'] = positionCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The whole definition, parts included, in the order given. A test in any status can be changed; a change applies to attempts started after it, never to those already taken. An active test must stay ready to be taken: a change after which a part would lack questions in a language of the test is refused, with the gaps listed.
         * @summary Replace the definition of a test
         * @param {string} testId 
         * @param {TestDefinitionDto} testDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTest: async (testId: string, testDefinitionDto: TestDefinitionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('updateTest', 'testId', testId)
            // verify required parameter 'testDefinitionDto' is not null or undefined
            assertParamExists('updateTest', 'testDefinitionDto', testDefinitionDto)
            const localVarPath = `/api/v1/tests/{testId}`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testDefinitionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestsApi - functional programming interface
 * @export
 */
export const TestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestsApiAxiosParamCreator(configuration)
    return {
        /**
         * Only a test without gaps: at least one part, enough questions in every part in every language of the test, and — when the test has instructions — one in each of its languages. A retired test comes back only while no other test that is not retired has its name. Activating an active test changes nothing.
         * @summary Make a draft active, or bring a retired test back
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateTest(testId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateTest(testId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestsApi.activateTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Tests come in series — the closing test of a stage for one position after another — and differ in a detail. The copy is a draft named after the original with \"(kopia)\", or \"(kopia 2)\" and on when that name is taken.
         * @summary Copy a test into a new draft
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyTest(testId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyTest(testId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestsApi.copyTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a test, as a draft
         * @param {TestDefinitionDto} testDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTest(testDefinitionDto: TestDefinitionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTest(testDefinitionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestsApi.createTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Only a draft that has never been active: a test that has been in use may have attempts behind it, and is retired rather than deleted.
         * @summary Delete a draft
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTest(testId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTest(testId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestsApi.deleteTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary A test with everything it is made of
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTest(testId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTest(testId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestsApi.getTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary What happened to a test, newest first
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestHistory(testId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefinitionHistoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestHistory(testId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestsApi.getTestHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary The pool of a saved test, as the question bank stands now
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestPool(testId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestPoolDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestPool(testId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestsApi.getTestPool']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List tests
         * @param {TestPurposeDto} [purpose] 
         * @param {TestStatusDto} [status] 
         * @param {string} [categoryId] Narrows to tests with a part drawing from this category.
         * @param {string} [q] A fragment of the name, letter case aside.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sort] Field and direction, updatedAt or name, for example \&quot;name,asc\&quot;. Newest change first by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTests(purpose?: TestPurposeDto, status?: TestStatusDto, categoryId?: string, q?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTests(purpose, status, categoryId, q, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestsApi.listTests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For the pool panel of the form, asked again as parts, purpose and languages change. Parts are checked as a save checks them; the name and the rest of the definition are not needed.
         * @summary The pool of a test as the form holds it, nothing saved
         * @param {TestPoolRequestDto} testPoolRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewTestPool(testPoolRequestDto: TestPoolRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestPoolDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewTestPool(testPoolRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestsApi.previewTestPool']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A retired test cannot be started any more; its definition and attempts stay. A draft has never been in use and is deleted instead. Retiring a retired test changes nothing.
         * @summary Retire an active test
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retireTest(testId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retireTest(testId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestsApi.retireTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The same draw a person taking the test gets: parts in their order, questions and answers shuffled within each part, every question once, by the rules of the pool. Each call draws anew. In a language with too few questions the draw is refused, with the gaps listed.
         * @summary Draw the test as a person could get it, nothing saved
         * @param {string} testId 
         * @param {string} locale A language of the test.
         * @param {string} [positionCode] The position of the person taking the test: only questions for every position or for this one are drawn. A whole category or chosen questions with nothing for it are left out; a part that draws needs its number for the position too, or the draw is refused. Absent for every question, whoever it is for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sampleTest(testId: string, locale: string, positionCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestSampleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sampleTest(testId, locale, positionCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestsApi.sampleTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The whole definition, parts included, in the order given. A test in any status can be changed; a change applies to attempts started after it, never to those already taken. An active test must stay ready to be taken: a change after which a part would lack questions in a language of the test is refused, with the gaps listed.
         * @summary Replace the definition of a test
         * @param {string} testId 
         * @param {TestDefinitionDto} testDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTest(testId: string, testDefinitionDto: TestDefinitionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTest(testId, testDefinitionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestsApi.updateTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestsApi - factory interface
 * @export
 */
export const TestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestsApiFp(configuration)
    return {
        /**
         * Only a test without gaps: at least one part, enough questions in every part in every language of the test, and — when the test has instructions — one in each of its languages. A retired test comes back only while no other test that is not retired has its name. Activating an active test changes nothing.
         * @summary Make a draft active, or bring a retired test back
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateTest(testId: string, options?: RawAxiosRequestConfig): AxiosPromise<TestDetailsDto> {
            return localVarFp.activateTest(testId, options).then((request) => request(axios, basePath));
        },
        /**
         * Tests come in series — the closing test of a stage for one position after another — and differ in a detail. The copy is a draft named after the original with \"(kopia)\", or \"(kopia 2)\" and on when that name is taken.
         * @summary Copy a test into a new draft
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyTest(testId: string, options?: RawAxiosRequestConfig): AxiosPromise<TestDetailsDto> {
            return localVarFp.copyTest(testId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a test, as a draft
         * @param {TestDefinitionDto} testDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTest(testDefinitionDto: TestDefinitionDto, options?: RawAxiosRequestConfig): AxiosPromise<TestDetailsDto> {
            return localVarFp.createTest(testDefinitionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Only a draft that has never been active: a test that has been in use may have attempts behind it, and is retired rather than deleted.
         * @summary Delete a draft
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTest(testId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTest(testId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary A test with everything it is made of
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTest(testId: string, options?: RawAxiosRequestConfig): AxiosPromise<TestDetailsDto> {
            return localVarFp.getTest(testId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary What happened to a test, newest first
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestHistory(testId: string, options?: RawAxiosRequestConfig): AxiosPromise<DefinitionHistoryDto> {
            return localVarFp.getTestHistory(testId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary The pool of a saved test, as the question bank stands now
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestPool(testId: string, options?: RawAxiosRequestConfig): AxiosPromise<TestPoolDto> {
            return localVarFp.getTestPool(testId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List tests
         * @param {TestPurposeDto} [purpose] 
         * @param {TestStatusDto} [status] 
         * @param {string} [categoryId] Narrows to tests with a part drawing from this category.
         * @param {string} [q] A fragment of the name, letter case aside.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sort] Field and direction, updatedAt or name, for example \&quot;name,asc\&quot;. Newest change first by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTests(purpose?: TestPurposeDto, status?: TestStatusDto, categoryId?: string, q?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): AxiosPromise<TestPageDto> {
            return localVarFp.listTests(purpose, status, categoryId, q, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * For the pool panel of the form, asked again as parts, purpose and languages change. Parts are checked as a save checks them; the name and the rest of the definition are not needed.
         * @summary The pool of a test as the form holds it, nothing saved
         * @param {TestPoolRequestDto} testPoolRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewTestPool(testPoolRequestDto: TestPoolRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TestPoolDto> {
            return localVarFp.previewTestPool(testPoolRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * A retired test cannot be started any more; its definition and attempts stay. A draft has never been in use and is deleted instead. Retiring a retired test changes nothing.
         * @summary Retire an active test
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retireTest(testId: string, options?: RawAxiosRequestConfig): AxiosPromise<TestDetailsDto> {
            return localVarFp.retireTest(testId, options).then((request) => request(axios, basePath));
        },
        /**
         * The same draw a person taking the test gets: parts in their order, questions and answers shuffled within each part, every question once, by the rules of the pool. Each call draws anew. In a language with too few questions the draw is refused, with the gaps listed.
         * @summary Draw the test as a person could get it, nothing saved
         * @param {string} testId 
         * @param {string} locale A language of the test.
         * @param {string} [positionCode] The position of the person taking the test: only questions for every position or for this one are drawn. A whole category or chosen questions with nothing for it are left out; a part that draws needs its number for the position too, or the draw is refused. Absent for every question, whoever it is for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sampleTest(testId: string, locale: string, positionCode?: string, options?: RawAxiosRequestConfig): AxiosPromise<TestSampleDto> {
            return localVarFp.sampleTest(testId, locale, positionCode, options).then((request) => request(axios, basePath));
        },
        /**
         * The whole definition, parts included, in the order given. A test in any status can be changed; a change applies to attempts started after it, never to those already taken. An active test must stay ready to be taken: a change after which a part would lack questions in a language of the test is refused, with the gaps listed.
         * @summary Replace the definition of a test
         * @param {string} testId 
         * @param {TestDefinitionDto} testDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTest(testId: string, testDefinitionDto: TestDefinitionDto, options?: RawAxiosRequestConfig): AxiosPromise<TestDetailsDto> {
            return localVarFp.updateTest(testId, testDefinitionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestsApi - interface
 * @export
 * @interface TestsApi
 */
export interface TestsApiInterface {
    /**
     * Only a test without gaps: at least one part, enough questions in every part in every language of the test, and — when the test has instructions — one in each of its languages. A retired test comes back only while no other test that is not retired has its name. Activating an active test changes nothing.
     * @summary Make a draft active, or bring a retired test back
     * @param {string} testId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApiInterface
     */
    activateTest(testId: string, options?: RawAxiosRequestConfig): AxiosPromise<TestDetailsDto>;

    /**
     * Tests come in series — the closing test of a stage for one position after another — and differ in a detail. The copy is a draft named after the original with \"(kopia)\", or \"(kopia 2)\" and on when that name is taken.
     * @summary Copy a test into a new draft
     * @param {string} testId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApiInterface
     */
    copyTest(testId: string, options?: RawAxiosRequestConfig): AxiosPromise<TestDetailsDto>;

    /**
     * 
     * @summary Create a test, as a draft
     * @param {TestDefinitionDto} testDefinitionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApiInterface
     */
    createTest(testDefinitionDto: TestDefinitionDto, options?: RawAxiosRequestConfig): AxiosPromise<TestDetailsDto>;

    /**
     * Only a draft that has never been active: a test that has been in use may have attempts behind it, and is retired rather than deleted.
     * @summary Delete a draft
     * @param {string} testId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApiInterface
     */
    deleteTest(testId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary A test with everything it is made of
     * @param {string} testId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApiInterface
     */
    getTest(testId: string, options?: RawAxiosRequestConfig): AxiosPromise<TestDetailsDto>;

    /**
     * 
     * @summary What happened to a test, newest first
     * @param {string} testId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApiInterface
     */
    getTestHistory(testId: string, options?: RawAxiosRequestConfig): AxiosPromise<DefinitionHistoryDto>;

    /**
     * 
     * @summary The pool of a saved test, as the question bank stands now
     * @param {string} testId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApiInterface
     */
    getTestPool(testId: string, options?: RawAxiosRequestConfig): AxiosPromise<TestPoolDto>;

    /**
     * 
     * @summary List tests
     * @param {TestPurposeDto} [purpose] 
     * @param {TestStatusDto} [status] 
     * @param {string} [categoryId] Narrows to tests with a part drawing from this category.
     * @param {string} [q] A fragment of the name, letter case aside.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sort] Field and direction, updatedAt or name, for example \&quot;name,asc\&quot;. Newest change first by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApiInterface
     */
    listTests(purpose?: TestPurposeDto, status?: TestStatusDto, categoryId?: string, q?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): AxiosPromise<TestPageDto>;

    /**
     * For the pool panel of the form, asked again as parts, purpose and languages change. Parts are checked as a save checks them; the name and the rest of the definition are not needed.
     * @summary The pool of a test as the form holds it, nothing saved
     * @param {TestPoolRequestDto} testPoolRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApiInterface
     */
    previewTestPool(testPoolRequestDto: TestPoolRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TestPoolDto>;

    /**
     * A retired test cannot be started any more; its definition and attempts stay. A draft has never been in use and is deleted instead. Retiring a retired test changes nothing.
     * @summary Retire an active test
     * @param {string} testId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApiInterface
     */
    retireTest(testId: string, options?: RawAxiosRequestConfig): AxiosPromise<TestDetailsDto>;

    /**
     * The same draw a person taking the test gets: parts in their order, questions and answers shuffled within each part, every question once, by the rules of the pool. Each call draws anew. In a language with too few questions the draw is refused, with the gaps listed.
     * @summary Draw the test as a person could get it, nothing saved
     * @param {string} testId 
     * @param {string} locale A language of the test.
     * @param {string} [positionCode] The position of the person taking the test: only questions for every position or for this one are drawn. A whole category or chosen questions with nothing for it are left out; a part that draws needs its number for the position too, or the draw is refused. Absent for every question, whoever it is for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApiInterface
     */
    sampleTest(testId: string, locale: string, positionCode?: string, options?: RawAxiosRequestConfig): AxiosPromise<TestSampleDto>;

    /**
     * The whole definition, parts included, in the order given. A test in any status can be changed; a change applies to attempts started after it, never to those already taken. An active test must stay ready to be taken: a change after which a part would lack questions in a language of the test is refused, with the gaps listed.
     * @summary Replace the definition of a test
     * @param {string} testId 
     * @param {TestDefinitionDto} testDefinitionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApiInterface
     */
    updateTest(testId: string, testDefinitionDto: TestDefinitionDto, options?: RawAxiosRequestConfig): AxiosPromise<TestDetailsDto>;

}

/**
 * TestsApi - object-oriented interface
 * @export
 * @class TestsApi
 * @extends {BaseAPI}
 */
export class TestsApi extends BaseAPI implements TestsApiInterface {
    /**
     * Only a test without gaps: at least one part, enough questions in every part in every language of the test, and — when the test has instructions — one in each of its languages. A retired test comes back only while no other test that is not retired has its name. Activating an active test changes nothing.
     * @summary Make a draft active, or bring a retired test back
     * @param {string} testId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApi
     */
    public activateTest(testId: string, options?: RawAxiosRequestConfig) {
        return TestsApiFp(this.configuration).activateTest(testId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Tests come in series — the closing test of a stage for one position after another — and differ in a detail. The copy is a draft named after the original with \"(kopia)\", or \"(kopia 2)\" and on when that name is taken.
     * @summary Copy a test into a new draft
     * @param {string} testId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApi
     */
    public copyTest(testId: string, options?: RawAxiosRequestConfig) {
        return TestsApiFp(this.configuration).copyTest(testId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a test, as a draft
     * @param {TestDefinitionDto} testDefinitionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApi
     */
    public createTest(testDefinitionDto: TestDefinitionDto, options?: RawAxiosRequestConfig) {
        return TestsApiFp(this.configuration).createTest(testDefinitionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Only a draft that has never been active: a test that has been in use may have attempts behind it, and is retired rather than deleted.
     * @summary Delete a draft
     * @param {string} testId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApi
     */
    public deleteTest(testId: string, options?: RawAxiosRequestConfig) {
        return TestsApiFp(this.configuration).deleteTest(testId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary A test with everything it is made of
     * @param {string} testId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApi
     */
    public getTest(testId: string, options?: RawAxiosRequestConfig) {
        return TestsApiFp(this.configuration).getTest(testId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary What happened to a test, newest first
     * @param {string} testId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApi
     */
    public getTestHistory(testId: string, options?: RawAxiosRequestConfig) {
        return TestsApiFp(this.configuration).getTestHistory(testId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary The pool of a saved test, as the question bank stands now
     * @param {string} testId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApi
     */
    public getTestPool(testId: string, options?: RawAxiosRequestConfig) {
        return TestsApiFp(this.configuration).getTestPool(testId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List tests
     * @param {TestPurposeDto} [purpose] 
     * @param {TestStatusDto} [status] 
     * @param {string} [categoryId] Narrows to tests with a part drawing from this category.
     * @param {string} [q] A fragment of the name, letter case aside.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sort] Field and direction, updatedAt or name, for example \&quot;name,asc\&quot;. Newest change first by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApi
     */
    public listTests(purpose?: TestPurposeDto, status?: TestStatusDto, categoryId?: string, q?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig) {
        return TestsApiFp(this.configuration).listTests(purpose, status, categoryId, q, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For the pool panel of the form, asked again as parts, purpose and languages change. Parts are checked as a save checks them; the name and the rest of the definition are not needed.
     * @summary The pool of a test as the form holds it, nothing saved
     * @param {TestPoolRequestDto} testPoolRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApi
     */
    public previewTestPool(testPoolRequestDto: TestPoolRequestDto, options?: RawAxiosRequestConfig) {
        return TestsApiFp(this.configuration).previewTestPool(testPoolRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A retired test cannot be started any more; its definition and attempts stay. A draft has never been in use and is deleted instead. Retiring a retired test changes nothing.
     * @summary Retire an active test
     * @param {string} testId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApi
     */
    public retireTest(testId: string, options?: RawAxiosRequestConfig) {
        return TestsApiFp(this.configuration).retireTest(testId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The same draw a person taking the test gets: parts in their order, questions and answers shuffled within each part, every question once, by the rules of the pool. Each call draws anew. In a language with too few questions the draw is refused, with the gaps listed.
     * @summary Draw the test as a person could get it, nothing saved
     * @param {string} testId 
     * @param {string} locale A language of the test.
     * @param {string} [positionCode] The position of the person taking the test: only questions for every position or for this one are drawn. A whole category or chosen questions with nothing for it are left out; a part that draws needs its number for the position too, or the draw is refused. Absent for every question, whoever it is for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApi
     */
    public sampleTest(testId: string, locale: string, positionCode?: string, options?: RawAxiosRequestConfig) {
        return TestsApiFp(this.configuration).sampleTest(testId, locale, positionCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The whole definition, parts included, in the order given. A test in any status can be changed; a change applies to attempts started after it, never to those already taken. An active test must stay ready to be taken: a change after which a part would lack questions in a language of the test is refused, with the gaps listed.
     * @summary Replace the definition of a test
     * @param {string} testId 
     * @param {TestDefinitionDto} testDefinitionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApi
     */
    public updateTest(testId: string, testDefinitionDto: TestDefinitionDto, options?: RawAxiosRequestConfig) {
        return TestsApiFp(this.configuration).updateTest(testId, testDefinitionDto, options).then((request) => request(this.axios, this.basePath));
    }
}

